"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var roundFloorBetweenDates = function roundFloorBetweenDates(_ref) {
  var isOnFuture = _ref.isOnFuture,
      start = _ref.start,
      end = _ref.end,
      moment = _ref.moment;
  var roundingDefault = moment.relativeTimeRounding();
  moment.relativeTimeRounding(Math.floor);
  moment.relativeTimeThreshold('s', 60);
  moment.relativeTimeThreshold('m', 60);
  moment.relativeTimeThreshold('h', 24);
  moment.relativeTimeThreshold('d', 31);
  moment.relativeTimeThreshold('M', 12);
  var timeRemaining = moment(isOnFuture ? start : end).fromNow(true);
  moment.relativeTimeRounding(roundingDefault);
  return timeRemaining;
};

var _default = roundFloorBetweenDates;
exports["default"] = _default;
//# sourceMappingURL=roundFloorBetweenDates.js.map